import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const LocationPinIcon = ({
  stroke,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.action.active;

  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.2703 15.4733C21.8989 10.8447 18.3325 2.75 12.0002 2.75C5.66778 2.75 2.10142 10.8447 6.73001 15.4733L11.2926 20.0416C11.6832 20.4327 12.3171 20.4327 12.7077 20.0416L17.2703 15.4733Z"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
      <circle
        cx="12.0001"
        cy="9.9498"
        r="2.4"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};
